(function (app) {

    app.provider("transactionGroupProductApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        //GETs
                        service.get = function (transactionGroupProductId) {
                            return complianceHubApiGateway.get("/TransactionGroupProducts/" + transactionGroupProductId);
                        }

                        service.getProductsForTransactionGroup = function (transactionGroupId) {
                            return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/TransactionGroupProducts");
                        }

                        service.getPublishedProducts = function (transactionGroupId) {
                            return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/PublishedProducts");
                        }

                        service.updateIsActive = function (transactionGroupProduct) {
                            return complianceHubApiGateway.put("/TransactionGroupProducts/" + transactionGroupProduct.Id, transactionGroupProduct);
                        }

                        service.updateExludeFromReviewQueue = function (transactionGroupProduct) {
                            return complianceHubApiGateway.put("/TransactionGroupProducts/" + transactionGroupProduct.Id + "/ExludeFromReviewQueue", transactionGroupProduct);
                        }


                        service.createTransactionGroupProduct = function (transactionGroupProduct) {
                            return complianceHubApiGateway.post("/TransactionGroupProducts/", transactionGroupProduct);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line